import { render, staticRenderFns } from "./LearningmaterialsBlock.vue?vue&type=template&id=1325870b"
import script from "./LearningmaterialsBlock.vue?vue&type=script&lang=js"
export * from "./LearningmaterialsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports